import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-mentor',
  imports: [RouterLink],
  templateUrl: './mentor.html',
})
export class Mentor {

}
